import { footerStyles } from "@insite/content-library/Pages/Footer";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";
// The below imports are taken from QA Spire:
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";

footerStyles.page = {
  fullWidth: [true, true, true, true, true],
  padding: 0,
  css: css`
        margin-top: 20px;
        padding-top: 0;
        border-top: 1px solid ${getColor("common.border")};
        background: linear-gradient(124deg, #2380a3 19%, #2b566d 81%);
        ${({ theme }: { theme: BaseTheme }) =>
      breakpointMediaQueries(theme, [
        null, css`overflow: visible;`,], "max",)}
    }
    `,
};